import React, { useContext } from "react";
import { CameraSection } from "../../context/CameraContext";
import { FiMoreVertical, FiArrowLeft, FiPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
const CameraList = () => {
  const { t } = useTranslation();
  const { CameraShowHideFunc } = useContext(CameraSection);

  return (
    <div>
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("دوربین")}</p>
        </div>
      </div>
      <div className="my-4" style={{ minHeight: "60vh" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="bg-white py-3 px-2 cameraLists col-9 d-flex justify-content-between align-items-center">
            <p className="fn m-0">{t("اتاق کار")}</p>
            <FiMoreVertical />
          </div>
          <div
            className="d-flex justify-content-between align-items-center
                    fn23 bg-primary text-white px-3"
            style={{ height: "53px", borderRadius: "8px" }}
          >
            <FiArrowLeft />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="bg-white py-3 px-2 cameraLists col-9 d-flex justify-content-between align-items-center">
            <p className="fn m-0">{t("اتاق کار")}</p>
            <FiMoreVertical />
          </div>
          <div
            className="d-flex justify-content-between align-items-center
                    fn23 bg-primary text-white px-3"
            style={{ height: "53px", borderRadius: "8px" }}
          >
            <FiArrowLeft />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="bg-white py-3 px-2 cameraLists col-9 d-flex justify-content-between align-items-center">
            <p className="fn m-0">{t("اتاق کار")}</p>
            <FiMoreVertical />
          </div>
          <div
            className="d-flex justify-content-between align-items-center
                    fn23 bg-primary text-white px-3"
            style={{ height: "53px", borderRadius: "8px" }}
          >
            <FiArrowLeft />
          </div>
        </div>
      </div>
      <div
        className="addCameraBtn text-white bg-primary px-3 m-auto cursor
            d-flex justify-content-between align-items-center"
        onClick={() => CameraShowHideFunc("addCamera")}
      >
        <FiPlus />
        <p className="fn m-0">{t("افزودن دوربین")}</p>
      </div>
    </div>
  );
};

export { CameraList };
